/* Zen & Zip — repeats the free-shipping nudge next to the cart drawer's
   Total line, since the main progress bar sits up near the top of the
   drawer and can scroll out of view once there's more than a line item
   or two. Threshold mirrors snippets/zz-shipping-threshold.liquid ($125)
   and assets/zz-announcement-cart-aware.js. Hidden once the cart already
   qualifies -- no need to remind someone who already has free shipping. */
(function () {
  var THRESHOLD_CENTS = 12500;
  var selfUpdating = false;

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + (amount.endsWith('.00') ? amount.slice(0, -3) : amount);
  }

  function upsert(totalsEl) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var note = totalsEl.parentNode.querySelector('[data-zz-cart-shipping-note]');
        var remaining = THRESHOLD_CENTS - cart.total_price;

        if (cart.item_count === 0 || remaining <= 0) {
          if (note) {
            selfUpdating = true;
            note.remove();
          }
          return;
        }

        var text = 'You’re ' + money(remaining) + ' away from free shipping.';
        if (note) {
          if (note.textContent !== text) {
            selfUpdating = true;
            note.textContent = text;
          }
          return;
        }

        note = document.createElement('p');
        note.setAttribute('data-zz-cart-shipping-note', '');
        note.className = 'zz-cart-shipping-note';
        note.textContent = text;
        selfUpdating = true;
        totalsEl.parentNode.insertBefore(note, totalsEl);
      })
      .catch(function () {});
  }

  function scan() {
    document.querySelectorAll('#CartDrawer .cart-drawer-subtotal__totals').forEach(upsert);
  }

  document.addEventListener('DOMContentLoaded', scan);

  if ('MutationObserver' in window) {
    var scheduled = false;
    new MutationObserver(function () {
      if (selfUpdating) {
        selfUpdating = false;
        return;
      }
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
